// store/slices/lienSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const lienSlice = createSlice({
  name: "lien",
  initialState: {
    selectedLien: null,
    isUpdated: false,
    index: null,
  },
  reducers: {
    setSelectedLien: (state, action) => {
      state.selectedLien = action.payload;
    },
    clearSelectedLien: (state) => {
      state.selectedLien = null;
    },
    updatedSelectedLien: (state, action) => {
      state.isUpdated = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
  },
});

export const {
  setSelectedLien,
  clearSelectedLien,
  updatedSelectedLien,
  setIndex,
} = lienSlice.actions;
export default lienSlice.reducer;
